import { Button } from '@eventbrite/eds-button';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';

const FormSubmitButton = ({
    buttonCTA,
    submitDisabled,
    buttonClasses,
    onClick,
    dataTestId,
    style,
    size,
    isLoading,
    __containerClassName,
}: any) => (
    <div className={buttonClasses}>
        <Button
            onClick={onClick}
            type="submit"
            style={style}
            size={size}
            disabled={submitDisabled}
            data-testid={dataTestId}
            __containerClassName={__containerClassName}
            isLoading={isLoading}
        >
            {buttonCTA}
        </Button>
    </div>
);

FormSubmitButton.propTypes = {
    buttonCTA: PropTypes.any.isRequired,

    submitDisabled: PropTypes.bool,
    buttonClasses: PropTypes.string,
    onClick: PropTypes.func,
    dataTestId: PropTypes.string,
    style: PropTypes.string,
    size: PropTypes.string,
    isLoading: PropTypes.bool,
    __containerClassName: PropTypes.string,
};

FormSubmitButton.defaultProps = {
    onClick: noop,
    style: 'fill',
    dataTestId: 'form-submit-button',
    size: 'block',
};

export default FormSubmitButton;
